import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import { defer } from 'react-router-dom'
import useStockStore from 'src/components/routes/stock/store'
import { getOldWorkflowRedirect } from '../helper'

export default async function loader() {
  const oldWorkflowRedirect = getOldWorkflowRedirect(
    '/stock/stockordertemplate/list'
  )
  if (oldWorkflowRedirect) return oldWorkflowRedirect

  logger.debug(
    '[loader] About to await AppState being ready in Order Templates loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Order Templates loader'
  )

  // Create a single promise that calls the API once
  const orderTemplatesPromise = useStockStore.getState().getOrderTemplates()

  // Return a deferred promise to enable React Router's built-in loading state
  return defer({
    data: Promise.all([orderTemplatesPromise])
      .then(() => true)
      .catch((error) => {
        logger.error('Loader Order Templates error: ', error)
        return false
      }),
  })
}
